import * as React from 'react'
import Page from 'components/presenter/page/Page'
import FillButton from 'components/presenter/buttons/FillButton'
import JetsoCard from 'components/presenter/jetso/JetsoCard'
import { Paper } from '@material-ui/core'
import { useTranslation, Link, useI18next } from 'gatsby-plugin-react-i18next'
import { useStore, newStoreId, authStoreId, companyStoreId } from 'stores'
import { usePageLoad } from 'libs/ui/pageLoad'
import Pagination from 'components/presenter/navigation/Pagination'
import cn from 'classnames'
import * as styles from './create.module.css'

const newsPerPage = 12

const JetsoListPage = ({location}) => {
  const { t } = useTranslation()
  const { navigate } = useI18next()
  const companyStore = useStore(companyStoreId)
  const newsStore = useStore(newStoreId)
  const authStore = useStore(authStoreId)
  const searchParams = new URLSearchParams(location.search)
  const page = searchParams.get('page') ? parseInt(searchParams.get('page'), 10) : 1
  const fetchNewsList = async (_page) => {
    if (newsStore.getters.currentPage() !== _page) {
      await newsStore.actions.fetchNewsList({
        page: _page,
        limit: newsPerPage
      })
    }
  }

  const newsRecord = newsStore.getters.getNewsRecord()

  const handlePageChange = (event, value) => {
    fetchNewsList(value)
    navigate(`/jetso/?page=${value}`)
  }

  const handlePageLoad = async () => {
    await fetchNewsList(page)
  }

  const { isPageLoaded } = usePageLoad({
    pageLoadDeps: [authStore.getters.isInitial(), companyStore.getters.getCompanyProfile()],
    onPageLoad: handlePageLoad
  })

  const render = () => {
    
    const body = () => {
      if (!isPageLoaded) {
        return <></>
      }
      if (!newsRecord.total) {
        return (
          <Paper className={cn(styles.paper, styles.noJetsoRoot)} elevation={2}>
          <p className={styles.txtNoJetso}>
            {t('jetso.noJetso')}
          </p>
        </Paper>
        )
      }
      return (
        <>
          <div className={styles.newsRoot}>
            {
              newsStore.getters.getNewsRecord().records.map((news) => <JetsoCard key={news._id} news={news}/>)
            }
          </div>
          <Pagination
            className={cn('mui-pagination', styles.pagination)}
            total={newsRecord.total}
            limit={newsPerPage}
            page={page}
            onChange={handlePageChange} />
        </>
      )
    }

    return (
      <>
        <div className={styles.titleSection}>
          <h1 className={styles.title}>{t('mainMenu.jetsoManagement')}</h1>
          <FillButton 
            className={cn(styles.btnUpdate, 'mui-button-link')}
          >
            <Link
              to="/jetso/create/">
              {t('jetso.createJetso')}
            </Link>
          </FillButton>
        </div>
        {
          body()
        }
      </>
    )
  }

  return (
    <Page
      className={styles.root}
      seoMeta={{
        title: t('mainMenu.jetsoManagement')
      }}
      isLoading={!isPageLoaded}
    >
      {render()}
    </Page>
  )
}

export default JetsoListPage